// extracted by css-extract-rspack-plugin
export default {"pageWrapper":"GivingActionForm_pageWrapper__GZZT7","formWrapper":"GivingActionForm_formWrapper__9HfmQ"};